import { createContext } from 'react';
import { TournamentContextType } from './types';

export const TournamentContext = createContext<TournamentContextType | null>(null);
